import { PropertyMetaData } from './property-meta-data';

export class GuidMetaData extends PropertyMetaData {

    protected override _type = 'Guid';

}
